import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ContactUsFormAPI, ContactUsFormPayload } from 'src/app/customcomponents/contact-us-form/contact-us-form.model';



@Injectable({
  providedIn: 'root',
})
export class ContactUsFormService {
  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService
  ) {}

  getContactUsFormTopics(): Observable<ContactUsFormAPI> {
    return this.http.get<ContactUsFormAPI>(
      this.occService.buildUrl(`getcontactus`)
    );
  }

  submitContactUsData(payload: ContactUsFormPayload) {
    return this.http.post(this.occService.buildUrl(`contactus`), payload);
  }
}
